import { Component, OnInit } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { BookmarkedQuestion, Evaluation, Question } from '../../interfaces/questionInterface';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { AnswerComponent } from '../../question/answer/answer.component';
import { TimeAgoPipe } from '../../pipes/time-ago.pipe';
import { bootstrapJournalBookmark } from '@ng-icons/bootstrap-icons';

@Component({
    selector: 'app-bookmarks',
    imports: [NgIconComponent, AnswerComponent, TimeAgoPipe, NgIconComponent],
    templateUrl: './bookmarks.component.html',
    styleUrl: './bookmarks.component.scss',
    providers: [provideIcons({ bootstrapJournalBookmark })]
})
export class BookmarksComponent implements OnInit {
  bookmarkedQuestions: BookmarkedQuestion[] = [];

  constructor(readonly questionService: QuestionService) { }

  ngOnInit(): void {
    this.questionService.getBookmarkedQuestions().then(result => {
      this.bookmarkedQuestions = result;
    });
  }
}
